module.exports = __webpack_public_path__ + "img/paint-11.4ac7f3b9.png";